var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnterFullscreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,5.32907052e-15 C15.5228475,5.32907052e-15 20,4.4771525 20,10 C20,15.5228475 15.5228475,20 10,20 C4.4771525,20 1.13686838e-13,15.5228475 1.13686838e-13,10 C1.13686838e-13,4.4771525 4.4771525,5.32907052e-15 10,5.32907052e-15 Z M13.8789832,9.67423478 C13.7277604,9.50628489 13.4690199,9.49272487 13.30107,9.64394763 L13.30107,9.64394763 L9.36996349,13.1835318 C9.30266757,13.2441253 9.25737158,13.3253297 9.24117108,13.4144244 C9.20073963,13.6367772 9.34821606,13.849806 9.57056891,13.8902374 L9.57056891,13.8902374 L13.8264413,14.6641025 C13.8607118,14.670334 13.8956377,14.6721644 13.9303718,14.6695492 C14.1557328,14.6525815 14.3246689,14.4561352 14.3077011,14.2307742 L14.3077011,14.2307742 L13.9829352,9.91732497 C13.9761364,9.82702496 13.9395767,9.7415307 13.8789832,9.67423478 Z M6.35456009,5.44939543 L6.30242099,5.44998957 C6.07705998,5.46695734 5.90812387,5.66340362 5.92509163,5.88876464 L5.92509163,5.88876464 L6.24985756,10.2022138 C6.25665638,10.2925139 6.29321607,10.3780081 6.35380959,10.445304 C6.50503235,10.6132539 6.76377292,10.6268139 6.93172281,10.4755912 L6.93172281,10.4755912 L10.8628293,6.93600701 C10.9301252,6.87541349 10.9754212,6.79420912 10.9916217,6.70511445 C11.0320531,6.4827616 10.8845767,6.26973284 10.6622239,6.22930138 L10.6622239,6.22930138 L6.40635146,5.45543634 C6.37208099,5.44920478 6.33715511,5.44737439 6.30242099,5.44998957 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterFullscreen);
export default __webpack_public_path__ + "static/media/enter-fullscreen.47581a26282faad9c1a2bfd35d9100ad.svg";
export { ForwardRef as ReactComponent };